import { render } from "./ImpotentsContent.vue?vue&type=template&id=68d08bc5"
import script from "./ImpotentsContent.vue?vue&type=script&lang=js"
export * from "./ImpotentsContent.vue?vue&type=script&lang=js"

import "./ImpotentsContent.vue?vue&type=style&index=0&id=68d08bc5&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__